module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Chapter 1"
    }
  }, [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch1"
    }
  }, [_c('b', [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('i', [_vm._v("July 1867")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYONE SAID THEY WERE DANGEROUS")]), _vm._v(". L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUREL ASSUMED")]), _vm._v(" it must be true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that didn’t stop her from taking another peek out her open sitting room window at one specific prisoner. One of the men currently repairing the fence framing her yard, the one so close she could see more detail than ever before. Without the benefit of a hat, he was squinting as he bent over a split piece of rotted wood. Though he had an iron shackle on his right ankle, he seemed unperturbed by the weight of the heavy metal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, he concentrated on the task at hand, positioning a fresh piece of lumber in the ruined wood’s place. The sharp lines of his face framed deeply tanned skin and brown hair that was already bleached by the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guard who stood by his side wasn’t Ollie. He was the stranger. In contrast to the prisoner, his skin was flushed and damp with sweat under his Stetson. He seemed both bored and ill at ease.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prisoner, however, continued to set the wood into its slot, then hammer it into place. He was now perched on one knee, his "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("expression quietly intent on his job. As with his shackle, he didn’t look uncomfortable or even that bothered by the oppressive heat.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurel craned her neck and looked at him even more closely. He had to be hot. Terribly hot, actually. His sleeves were rolled up to his elbows, revealing darkly tanned forearms lined with veins and more than a couple of scars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shifted, giving her a new view of his body. A line of perspiration trickled down his neck, right along a long scar that disappeared under the collar of his shirt. That perspiration made the thin fabric of his shirt stick to his skin, revealing just how muscular he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She knew she should look away. Her staring wasn’t seemly. Then, too, there wasn’t really anything to see that she hadn’t viewed before. But for the life of her, Laurel couldn’t seem to help herself. There was something about the man that had caught her regard and held on tight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ragtag team had been here for three days now. It was a charity mission, the idea of Sheriff Jackson. He’d served in the war with Laurel’s father and was a distant cousin of her mother’s. Laurel knew the sheriff felt sorry for her, essentially living on her own the way she was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, she was attempting to run what was left of a pitiful cattle operation with barely twenty head, little money for alfalfa for them to graze on, and far too many squatters in the area. She was exhausted and beginning to think she was never going to be able to keep the ranch going. No matter how hard she tried, there were never enough hours in the day to do everything that needed to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After she’d said as much to Will Jackson at church, he’d offered to send out a team of prisoners from the jail to repair her fence line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("Laurel was grateful her longtime friend was now the sheriff and could help her out. She was grateful for the prisoners’ help too. Would have been even more glad of it if the team hadn’t been overseen by Ollie Burnside—a man who hadn’t been much of a worker when he was a teen and seemed to have grown lazier with each year.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He also, Laurel decided, wasn’t very good at managing convicts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Otherwise Ollie would have noticed those men were hot and thirsty. Parched. Even she knew men worked a lot better if they were given water breaks every now and then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unable to stop herself, her gaze fastened again on the man with the scars. He was working as industriously as ever, but his movements had slowed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was no doubt suffering from the heat. Her heart broke for him. All men—even criminals—deserved kindness. Giving one a sip of water in this heat was surely the least anyone could do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And since the pair of guards seemed incapable of doing such a thing, Laurel knew that bit of kindness needed to come from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes. That was something her parents would have expected her to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what would the prisoner with the scars do if she brought him a ladle of water? Would he snatch it from her, scare her half to death, and make her wish she’d never contemplated such a kindness?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or would he take it gratefully?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picturing the moment, she let her imagination fly. Perhaps he would take the ladle, meeting her gaze when their fingertips brushed. Smile knowingly when she shivered from the tingles of awareness sliding through her body as he brought the ladle to his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("Or would he look at the proffered water and speak? Maybe he would simply thank her. Maybe he would say something more.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And what would she do if he did speak? Would she reply? Dare to smile? Lost in her dreams, in her thoughts about the two of them meeting at last, she shivered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laurel, step away from the window this minute!” Bess called, startling her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurel jerked upright so abruptly that she knocked a book off the table next to her. It landed on the floor with a resounding "), _c('i', [_vm._v("thud")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess yelped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which no doubt startled the whole chain gang working in her yard. Laurel knew because more than one man had straightened and was now staring her way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh! Had she ever been so mortified?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laurel, you really must present yourself in a more genteel manner,” Bess chastised. “Why, those men out there are going to see you ogling them!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurel was pretty sure they already had. But, unwilling to share that fact, she concentrated on saving what little bit of self-respect she had. “I wasn’t gawking at them.” After all, she was only ogling "), _c('i', [_vm._v("one")]), _vm._v(" man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you were doing, it wasn’t seemly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurel supposed Bess was right. She’d thought so herself just moments ago. But coming from Bess . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here she was an orphan, barely hanging on to what little bit of property she had. Bess and Jerome, her stepsiblings who’d arrived a little more than six months ago, didn’t help much. Actually, they didn’t seem to be interested in Red Roan Ranch at all. Unless they were discussing how much it was worth, what could be gained by selling it. Frustrated with the whole situation, Laurel slapped her hand against the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("Which drew the men’s attention back to her yet again.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feeling her face catch on fire, Laurel turned away, but not before sensing her prisoner’s scorching gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, after three days of watching him, she met his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared at her intently. As if he had all the time in the world to stare at her. As if he couldn’t look away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips opened in wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laurel!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Resolutely, she shut her mouth before she caught flies, then turned to face her bossy stepsister. Bess was still glaring at her hard enough to sour buttermilk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop yelling at me, Bess. I’m not doing anything wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re creating a spectacle of yourself, watching the prisoners like a loose woman. It’s improper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Bess always did when Laurel didn’t back down immediately, she harrumphed and then walked away, but not before flicking her dark-green taffeta skirts in disgust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once again alone in the sitting room, Laurel wondered how much longer she was going to be able to handle her stepsister’s so-called help. At times like this, she feared she wouldn’t make it another day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurel’s father had died in the war, and after a whole interminable year of mourning, her mother had remarried three years ago. Wayne Vance had been a good man, a kind man, and Laurel had been happy for her mother. He’d also had his own land, a sprawling estate two towns over. So he’d had no issue with her mother making sure Red Roan Ranch went directly to Laurel in the unlikely event of her death, especially since Laurel’s brother, Anderson, had also died in the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then, when both her mother and stepfather died in last "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("winter’s influenza epidemic, everything Laurel had never wanted to happen had. She was the sole owner of a thousand acres of prime land just south of Fort Worth, near the small town of Sweetwater. It not only had a creek and several ponds, but it was also fertile farmland.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess and Jerome were supposed to have been happy with their father’s land. But instead of holding on to it, they sold their inheritance the moment they could and, Laurel heard, for far less than it was worth. Then they’d gone down to New Orleans and Jackson, Mississippi, and spent every last dime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which was why they were now living with Laurel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost daily someone came and offered to buy her land. Though her stepsiblings kept pressuring her to sell, she’d refused. Not only would selling make her homeless, but she’d have to figure out what else to do with her life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t have other goals. She liked her ranch. She wanted to keep it, wanted to live there. She wanted to increase her herd, send some to market. The land and cattle were her links to her identity. Her reminders that war and disease hadn’t ruined everything in her life. Only most of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was why, when Will mentioned that a crew of six men who were serving short jail terms for minor infractions needed work, and that he was thinking they maybe could do some work on her property, she said she’d be happy for their assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess and Jerome had been up in arms when she told them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then she pointed out that no impropriety would be taking place since the men would be chained and guarded. She also took care to point out that the work needed to be done either by the men or by them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They’d given in easily enough then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was starting to understand why her mother had never had "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("much respect for them. She’d said time and again that there were some folks who did and others who waited for things to be done for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Red Roan Ranch to stay hers, it had to make a profit. Since she needed strong men like these prisoners who could work hard to help make that happen, she needed them hydrated at the very least.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grateful to have come to a decision at last, she strode out to the kitchen that was slightly detached from the house, poured some cool water into a pail, added two chunks of precious ice, and took hold of a large ladle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was going to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was going to stop staring out windows, open up her front door, and walk outside. She was going to approach those men and offer them some water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After smoothing her hair back off her face, she opened the door and walked toward the group of men. The walk was a short distance. But as each man stilled and watched her progress, Laurel felt as though she were walking two miles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that she was outside and away from the shade of her house, trickles of perspiration slid along her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second guard, the stranger, the one who was most definitely not Ollie, strode to her side. He greeted her with an oily smile and the smallest of respectful nods. “Miss Tracey. What can I do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s Foster Howell,” he interjected. “Surely you remember? We met at the party on the square three years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t remember that party. Mr. Howell wasn’t anyone she would have remembered speaking to if they had. He was rather coarse and crude. But since she couldn’t very well admit "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("such a thing, she played her part. “Yes, yes, of course, Mr. Howell. It’s a pleasure to see you again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Indeed, miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Casting a glance at the line of men still staring at her, she held up her pail and ladle. “It’s so warm. I thought I’d bring the men some water.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Looking eager, he reached for the pail’s handle. “That is too kind of you. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sixth sense told her he wouldn’t share the water with the convicts. Besides, she’d seen him and Ollie sip from flasks from time to time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Howell, I don’t mind giving it to them myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man looked appalled by the idea. “Certainly not, Miss Tracey. A lady like you needs to stay far away from these men. I believe Mr. Burnside told you they could be dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glanced at the line of men again. “Sheriff Jackson said they weren’t dangerous. That some were only convicted because of money owed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All men are dangerous. Especially around a woman like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A flicker of unease slid down her spine. Foster Howell could, indeed, be right. The war had taught them all that much could happen to the best of people under the worst of circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The right thing to do would be to hand him the pail and leave. To go back inside and busy herself with chores, then sit in silence and wait for the hours to pass. To try to converse with Bess about things that didn’t matter. To hold her tongue when Jerome sat at her father’s desk and attempted to look important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she couldn’t do that for another day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother taught me to treat others as I would like to be treated, Mr. Howell. I’ll take my chances now.” Before he could "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("caution her to stay away yet again, Laurel approached the line of men.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now not one of them was even pretending to work on the fence. Suddenly, they seemed larger, more foreboding, and harder than she’d previously thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were dirty and stained. They smelled of grime and sweat and disappointment. Upon closer inspection, she noticed their cheeks were hollow and their expressions as varied as their appearances. Some of them looked wary, others eager. All, however, looked terribly thirsty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Telling herself she was merely doing a good deed, she walked to the man closest to her, the man who had consumed her thoughts and vision for the last three days. He straightened when she got close. When she stopped, he inclined his head respectfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His voice was deep and gravelly. Better than she had imagined. “Sir. I . . . I brought you men some water. Would you care for any?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a pause, he spoke again. “I would at that, miss,” he replied in a slow drawl. “This is kind of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was so mannerly. Even out in the heat fixing fences with an iron shackle cutting into his ankle. And his eyes . . . well, they were proving to be even more mesmerizing up close. He had blue eyes. Not gray blue. Not pale blue. Blue like bluebonnets. Blue like the summer sky in July.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beautiful, piercing blue eyes framed by dark eyelashes. Fastened directly on her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Y’all are fixing my fence in the hot July sun. It’s the least I could do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those blue eyes gleamed. “It ain’t the least. It’s more than we expected. And, I must admit, much appreciated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled at him before remembering she shouldn’t do such "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("a thing. Hoping he didn’t notice her hands were shaking, she held the pail toward him, allowing him to pick up the ladle and quench his thirst without her assistance.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He closed his eyes with the first sip, then sipped again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One, two droplets of water remained on his bottom lip. The beads stayed there, taunting her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he swiped his lip with his tongue, she inhaled sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the other men snickered softly, her convict grinned, showing a truly fine set of teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Watch yourself, Baker,” Mr. Howell called out. “You ain’t out yet.” Sounding gleeful, he added, “And there’s no guarantee anyone is even going to want you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ignoring the threat, the man—Baker—dipped the ladle into the pail again, then brought the water to his parched lips. Laurel watched each movement with bated breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he released the ladle’s handle, giving her leave to attend to the next prisoner, he said, “He’s right, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You shouldn’t be out here. A woman like you shouldn’t be anywhere near a rough lot like us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You . . . you seem all right, Mr. Baker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am all right.” Looking amused, he smiled, triggering the startling appearance of twin dimples. “But that don’t mean you should be anywhere near me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before she could respond to that, Ollie strode forward. “Quiet, Baker, or you’ll feel the mark of my whip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like lightning, Baker turned on him. “Don’t threaten me,” he bit out, his voice hard and sharp. As far from the gentlemanly drawl as was possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Laurel’s surprise, Ollie stopped in his tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moving on to the next prisoner, she handed him the ladle. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("As he drank his fill, she looked back at Baker. Pointedly ignoring Ollie’s irritation, she said, “Mr. Baker, what did he mean about someone wanting you tomorrow?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow is the first day I’m eligible to be released.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled at him. “Why, that’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t smile in return. “It’s only wonderful if I can get hired. That’s the terms of it. Someone has to hire me tomorrow for me to be released.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moving down the line, she smiled at the convict who greeted her with a head bob and a low “Miss” before passing on the ladle. While the man sipped gratefully, she continued her conversation with Baker. “And if no one does?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I might have the good fortune to be doing more chores for you in the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feeling a bit speechless, she stared at him in wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just a bit too long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bring it over here, miss,” another convict called out. His voice suggestive and low, he added, “I’ll take a sip of whatever you got.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baker tensed. “Just give that pail to Watters there, miss,” he said quietly. “We’ll take care of ourselves now. One of the guards can set it outside your door when we leave. Go on in now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the man she’d been giving water to held out his hands for the pail, her convict said, “What’s your name, miss?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laurel,” she whispered. “Laurel Tracey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss Tracey, beg pardon, but you are a distraction. And I fear too much temptation for the likes of us. Go on in now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should be. Now, go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mind spinning, she did as he bid. She gave the pail to the prisoner and turned away. As she walked back to the house, she "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("heard the low murmur of masculine voices, followed by the "), _c('i', [_vm._v("clank")]), _vm._v(" of the ladle against the pail. But she also sensed eyes watching her departure.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tilting her chin down, she made sure to keep her pace steady. And tried not to think about how one man’s attention could rattle her so much.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30864383","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718078218_Chapter_1.vue
// module id = 81
// module chunks = 0